import { RouteObject } from 'react-router-dom'

import { default as Profile } from '.'
import { PageLayout } from '../../../common/app'

export const profileRoutes: RouteObject[] = [
  {
    path: '/settings/profile',
    element: (
      // htmlTitleOnly: the page renders its own identity header as the visual
      // title, and the standard PageHeader would otherwise show the reports
      // date filter, which has no meaning here.
      <PageLayout title="My Profile" htmlTitleOnly alignMainContent="center">
        <Profile.MyProfile.Component />
      </PageLayout>
    ),
    loader: Profile.MyProfile.Loader,
  },
]
